import '../styles/global.css';

export { default } from '@uhg-abyss/core/next-app';
